import type { TrackingEvent } from './types';
import { TrackingEventType } from './types';
import { trackEvent } from './request';

/**
 * Track an impression event
 * @param impressionId Unique impression ID
 * @param metadata Optional additional metadata
 */
export async function trackImpression(
  impressionId: string,
  metadata?: Record<string, any>
): Promise<void> {
  const event: TrackingEvent = {
    type: TrackingEventType.IMPRESSION,
    impressionId,
    timestamp: Date.now(),
    metadata,
  };

  await trackEvent(event);
}

/**
 * Track a click event
 * @param impressionId Unique impression ID
 * @param metadata Optional additional metadata
 */
export async function trackClick(
  impressionId: string,
  metadata?: Record<string, any>
): Promise<void> {
  const event: TrackingEvent = {
    type: TrackingEventType.CLICK,
    impressionId,
    timestamp: Date.now(),
    metadata,
  };

  await trackEvent(event);
}
